import { createConnectedStore, withLogger } from 'undux';

export default createConnectedStore({
  stickyBanner: false,
  mainMenuOffset: 0,
  playlistIndex: 0
}, withLogger);
